import * as angular from "angular";

export class DuplicatesService {
    private $http: any;
    private v2Root: string;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/duplicates";
    }

    all(): Promise<object> {
        return this.$http.get(this.v2Root + "/all");
    }
    merge(data: object): Promise<object> {
        return this.$http.post(this.v2Root + "/merge", data);
    }
    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/update/" + data.id, data);
    }
    latest(): Promise<object> {
        return this.$http.get(this.v2Root + "/latest");
    }
}
angular.module("vcServices").service("DuplicatesService", DuplicatesService);
